export const HERO_VARIANTS = {
  default: {
    badge: "Fahrer-Plätze frei · DE · AT · CH",
    line1: "Autos überführen.",
    line2: "Fair bezahlt, flexibel & seriös.",
    sub: "Verdiene Geld als Fahrzeugüberführer bei TSU-Partners – ganz ohne eigenen Pkw. Du brauchst nur einen Führerschein der Klasse B. Transparent, mit direkter Betreuung per WhatsApp.",
    microtrust: "Antwort meist in wenigen Minuten · Keine Gebühren · 100 % seriös",
    cta: "Jetzt kostenlos auf WhatsApp informieren",
  },
  v2: {
    badge: "Dein neuer Nebenjob",
    line1: "Autos überführen.",
    line2: "Bargeld einsacken.",
    sub: "Flexibel als Fahrzeugüberführer bei TSU-Partners durchstarten – DE, AT & CH. Kein eigenes Auto nötig, nur dein Führerschein. Perfekt nebenbei.",
  },
};

export const DEFAULT_WHATSAPP_NUMBER = "4916098471866";

// Checkout-/Anmelde-Link (CopeCart)
export const CHECKOUT_LINK = "https://www.copecart.com/products/707a4dc0/checkout";

export const KM_RATE_MIN = 0.8;
export const KM_RATE_MAX = 1.35;

// Beispiel-Touren mit realistischen Strecken (km) – Bezahlung wird aus km × Satz berechnet
export const EXAMPLE_ORDERS = [
  { car: "BMW 3er Limousine", from: "Bremen", to: "München", km: 700 },
  { car: "Audi A6 Avant", from: "Hamburg", to: "Berlin", km: 290 },
  { car: "VW Golf 8", from: "Köln", to: "Frankfurt", km: 190 },
  { car: "Mercedes C-Klasse", from: "Stuttgart", to: "Wien (AT)", km: 660 },
  { car: "Audi Q5", from: "Zürich (CH)", to: "München", km: 305 },
];

// Haupt-WhatsApp-Nummer (Standard, wenn kein Affiliate-Partner gesetzt ist)
export const buildWhatsAppLink = (number) => {
  const n = String(number || "").replace(/\D/g, "");
  const text = "Hallo! Ich möchte gerne als Fahrer loslegen.";
  return `https://api.whatsapp.com/send/?phone=${n}&text=${encodeURIComponent(text)}&type=phone_number&app_absent=0`;
};

export const WHATSAPP_MAIN_LINK = buildWhatsAppLink("491733482855");

export const WHATSAPP_LINK = WHATSAPP_MAIN_LINK;

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_fahrzeug-funnel/artifacts/n5t040b5_Design%20ohne%20Titel%20%285%29.png";

export const HERO_VIDEO = "/hero-video.mp4";

export const STATS = [
  { value: "bis 608 €", label: "pro Tour möglich" },
  { value: "0,80–1,35 €", label: "pro gefahrenem km" },
  { value: "DE · AT · CH", label: "Aufträge in der DACH-Region" },
  { value: "nur Kl. B", label: "Führerschein genügt" },
];

export const BENEFITS = [
  {
    icon: "Wallet",
    title: "Faire, transparente Vergütung",
    desc: "Klare Abrechnung pro Fahrt – ohne versteckte Abzüge. Auf langen Strecken sind bis zu 608 € pro Tour möglich.",
  },
  {
    icon: "CalendarClock",
    title: "Freie Zeiteinteilung",
    desc: "Du entscheidest, wann und wie oft du fährst. Ideal als Nebenverdienst, Hauptjob oder für Studierende.",
  },
  {
    icon: "Gauge",
    title: "Moderne Fahrzeuge",
    desc: "Du überführst aktuelle Neuwagen, Leasingrückläufer und Mietwagen namhafter Marken.",
  },
  {
    icon: "MapPinned",
    title: "Aufträge in der DACH-Region",
    desc: "Überführungen in Deutschland, Österreich und der Schweiz – oft direkt aus deiner Nähe.",
  },
  {
    icon: "BadgeCheck",
    title: "Kein eigenes Auto nötig",
    desc: "Du brauchst keinen eigenen Pkw – ein gültiger Führerschein der Klasse B genügt.",
  },
  {
    icon: "Zap",
    title: "Pünktliche Auszahlung",
    desc: "Deine Vergütung kommt zuverlässig per Banküberweisung nach erledigter Überführung.",
  },
];

export const STEPS = [
  {
    step: "01",
    title: "WhatsApp starten",
    desc: "Schreib uns unverbindlich über WhatsApp und prüfe in 2 Minuten, ob in deiner Region Aufträge frei sind – ganz ohne Lebenslauf.",
  },
  {
    step: "02",
    title: "Kurze Einweisung",
    desc: "Wir prüfen deine Daten (Führerschein Klasse B) und weisen dich ein. Keine Vorerfahrung nötig.",
  },
  {
    step: "03",
    title: "Fahren & bezahlt werden",
    desc: "Übernimm deine erste Überführung in deiner Nähe, bring das Fahrzeug ans Ziel und werde fair und pünktlich bezahlt.",
  },
];

export const OBJECTIONS = [
  { icon: "ShieldCheck", q: "Ist das wirklich seriös?", a: "Ja. Bei TSU-Partners bekommst du echte Überführungsaufträge und wirst persönlich per WhatsApp betreut. Impressum und Kontaktdaten findest du transparent auf dieser Seite." },
  { icon: "GraduationCap", q: "Brauche ich Erfahrung?", a: "Nein. Eine kurze Einweisung reicht völlig aus. Voraussetzung ist nur ein gültiger Führerschein der Klasse B – auch in der Probezeit." },
  { icon: "Wallet", q: "Wie funktioniert die Bezahlung?", a: "Fair und transparent pro erledigter Überführung, ohne versteckte Abzüge. Die Auszahlung erfolgt per Banküberweisung." },
  { icon: "MessageCircle", q: "Wie starte ich?", a: "Ganz einfach per WhatsApp in unter 2 Minuten – ohne Papierkram. Wir melden uns direkt bei dir zurück." },
];

export const COMMUNITY_IMAGE =
  "https://customer-assets.emergentagent.com/job_fahrzeug-funnel/artifacts/ye9f0zd2_Bild_2026-06-18_175623052.png";

export const CONTACT = {
  company: "TSU DIGITAL MARKETING — TSU PARTNERS",
  owner: "Jihad Nehme",
  address: "c/o IP-Management #8574, Ludwig-Erhard-Straße 18, 20459 Hamburg",
  email: "info@tsupartners.de",
  phone: "+49 176 34283721",
  whatsapp: "+49 160 98471866",
  taxId: "DE454024386",
};

export const TESTIMONIALS = [
  {
    name: "Marco",
    vehicle: "Mercedes C-Klasse",
    text: "Heute mal C-Klasse — so verdammt geil dieser Job!",
    image: "https://customer-assets.emergentagent.com/job_tsu-connect/artifacts/27nwu9po_WhatsApp%20Image%202026-05-25%20at%2000.12.38%20%281%29.jpeg",
  },
  {
    name: "Dennis",
    vehicle: "Lynk & Co",
    text: "Meine erste Überführung erfolgreich bestanden! Vielen Dank für die Unterstützung.",
    image: "https://customer-assets.emergentagent.com/job_tsu-connect/artifacts/q2ivhrmn_WhatsApp%20Image%202026-05-25%20at%2000.12.36.jpeg",
  },
  {
    name: "Sergej",
    vehicle: "Audi A6 Sportback",
    text: "Zweites Auto überführt. Funktioniert super, 145 €. Danke dir, Carlos!",
    image: "https://customer-assets.emergentagent.com/job_tsu-connect/artifacts/p8m7nzg4_WhatsApp%20Image%202026-05-25%20at%2000.12.37%20%284%29.jpeg",
  },
  {
    name: "Tobias",
    vehicle: "Ford Focus",
    text: "Perfekt, klingt super 👍👍 — Ford Focus erfolgreich überführt.",
    image: "https://customer-assets.emergentagent.com/job_tsu-connect/artifacts/8msml2jj_WhatsApp%20Image%202026-05-25%20at%2000.12.37%20%283%29.jpeg",
  },
  {
    name: "Patrick",
    vehicle: "VW & BMW",
    text: "Mega geiles Auto — die nächste Tour gleich noch hinterher.",
    image: "https://customer-assets.emergentagent.com/job_tsu-connect/artifacts/qz3njslh_WhatsApp%20Image%202026-05-25%20at%2000.12.38%20%282%29.jpeg",
  },
  {
    name: "Kevin",
    vehicle: "BMW · Audi · Tesla",
    text: "BMW, Audi und sogar Tesla — hoffe, du hattest Spaß gehabt!",
    image: "https://customer-assets.emergentagent.com/job_tsu-connect/artifacts/75flb3c1_WhatsApp%20Image%202026-05-25%20at%2000.12.37.jpeg",
  },
];

export const FAQS = [
  {
    q: "Ist TSU-Partners seriös?",
    a: "Ja. Bei TSU-Partners bekommst du echte Überführungsaufträge in der DACH-Region und wirst persönlich betreut. Impressum, Anschrift und Kontaktdaten findest du unten auf der Seite.",
  },
  {
    q: "Brauche ich ein eigenes Auto?",
    a: "Nein. Du überführst die Fahrzeuge unserer Auftraggeber. Ein gültiger Führerschein Klasse B genügt – kein eigener Pkw nötig.",
  },
  {
    q: "Brauche ich Vorerfahrung?",
    a: "Nein. Eine kurze Einweisung reicht aus. Wichtig ist nur ein gültiger Führerschein der Klasse B – auch in der Probezeit möglich.",
  },
  {
    q: "Wie werde ich bezahlt?",
    a: "Transparent pro erledigter Überführung, ohne versteckte Abzüge. Die Auszahlung erfolgt per Banküberweisung. Die Höhe richtet sich nach der Strecke (ca. 0,80–1,35 € pro km).",
  },
  {
    q: "Kann ich Hin- und Rückfahrten buchen?",
    a: "Ja. Du kannst Hin- und Rückfahrt buchen und so an einem Tag doppelt fahren und verdienen.",
  },
  {
    q: "Bin ich während der Fahrt versichert?",
    a: "Ja. Die Fahrzeuge sind über den jeweiligen Auftraggeber versichert. Alle Details klären wir vor deiner ersten Tour.",
  },
  {
    q: "In welchen Ländern kann ich fahren?",
    a: "In der gesamten DACH-Region: Deutschland, Österreich und der Schweiz – oft direkt aus deiner Nähe.",
  },
  {
    q: "Kostet mich die Registrierung etwas?",
    a: "Nein. Die Registrierung als Fahrer bei TSU-Partners ist kostenlos und unverbindlich.",
  },
];

export const MARQUEE_ITEMS = [
  "EXKLUSIVE FAHRZEUGE",
  "TOP VERGÜTUNG",
  "DACH-REGION",
  "FREIE ZEITEINTEILUNG",
  "608€+ PRO TOUR",
  "NUR FÜHRERSCHEIN NÖTIG",
  "SCHNELLE AUSZAHLUNG",
];
